#import "../fragments/AutomationLiveFields.graphql"

query AutomationLive($id: ID!) {
  automation(id: $id) {
    ...AutomationLiveFields
  }
}
